import React from "react";
import "./howorbixworkssection.component.css"
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const HowOrbixWorksSection = () => {
  return (
    <section className="container text-center pb-2 mt-n5 pt-n5 mt-md-4 pt-md-4 mt-lg-5 pt-lg-5">
      <h2 className="h1 text-center pt-1 pt-xl-3 mb-lg-4">How Orbix Works in 4 Simple Steps</h2>

      <Swiper
        modules={[Pagination]}
        spaceBetween={8}
        slidesPerView={1}
        pagination={{ clickable: true }}
        breakpoints={{
          500: {
            slidesPerView: 2,
            spaceBetween: 8,
          },
          800: {
            slidesPerView: 3,
            spaceBetween: 8,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 8,
          },
        }}
        className="px-2"
      >
        {/* Slide */}
        <SwiperSlide className="h-auto py-3">
          <div className="card card-body mx-2 h-100 text-start">
            <div className="step-number">
              <div className="step-number-inner">1</div>
            </div>
            <h3 className="h5 pt-3 pb-1 mb-2">Integrate & Onboard</h3>
            <p className="mb-0">
              We onboard your NDT vendors. Setup is fast and seamless—no
              disruption to your current workflow.
            </p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="card h-100 card-body mx-2  text-start">
            <div className="step-number">
              <div className="step-number-inner">2</div>
            </div>
            <h3 className="h5 pt-3 pb-1 mb-2">Real-Time Data Capture</h3>
            <p className="mb-0">
              As inspections are performed, data—images, reports,
              readings—flows directly and securely into Orbix, regardless of
              the vendor’s tools or reporting system.
            </p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="card h-100 card-body mx-2  text-start ">
            <div className="step-number">
              <div className="step-number-inner">3</div>
            </div>
            <h3 className="h5 pt-3 pb-1 mb-2">AI + Auditor Review</h3>
            <p className="mb-0">
              Orbix AI scans every incoming report to flag potential compliance
              risks and anomalies. Our expert auditors validate these findings
              in real time, ensuring confidence and accuracy.
            </p>
          </div>
        </SwiperSlide>

        <SwiperSlide>
          <div className="card h-100 card-body mx-2  text-start ">
            <div className="step-number">
              <div className="step-number-inner">4</div>
            </div>
            <h3 className="h5 pt-3 pb-1 mb-2">Actionable Insights</h3>
            <p className="mb-0">
              Our AI delivers clear, practical insights that help you stay
              ahead of delays, improve vendor performance, and control project
              costs—all from validated inspection data.
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </section>
  );
};

export default HowOrbixWorksSection;